import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "4dcb8bfb-0aec-4315-80be-60aa473ba69d", content: "Phase shift: 0</br>Phase velocity: ∞", options: {} },
  { id: "029fc427-7aeb-4ca2-8fc5-8db32f5e0f12", content: "Phase shift: π/4</br>Phase velocity: 0 m/s", options: {} },
  { id: "1c32d85f-53fb-4a66-89df-88b710b41870", content: "Phase shift: π/2</br>Phase velocity: 343 m/s", options: {} },
  { id: "eae3972e-3da0-4a0d-acf1-d5f0e6684c36", content: "Phase shift: 2π</br>Phase velocity: 396 m/s", options: {} },
];

export const task: Task = {
  id: "a72b61f2-e3a8-4484-ac5a-4b2b61c68e80",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4dcb8bfb-0aec-4315-80be-60aa473ba69d"],
};
